import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { createRef, Component, Fragment } from 'react';
import { pick } from 'lodash-es';
import { connect, dispatch } from '../../../store';
import { configureTreeBuilder } from './builder.redux';
import * as constants from './constants';
import { isPointInNode } from './helpers';
import { Connector as ConnectorModel } from './models';
import { SvgCanvas } from './SvgCanvas';
import { Node } from './Node';
import { Connector } from './Connector';
import { is } from 'immutable';
export var TreeBuilderComponent = /*#__PURE__*/function (_Component) {
  _inherits(TreeBuilderComponent, _Component);

  var _super = _createSuper(TreeBuilderComponent);

  function TreeBuilderComponent(props) {
    var _this;

    _classCallCheck(this, TreeBuilderComponent);

    _this = _super.call(this, props);

    _this.findNodeByPoint = function (point) {
      return _this.props.tree.nodes.find(isPointInNode(point));
    };

    _this.findDuplicateConnector = function (nodeId1, nodeId2) {
      return _this.props.tree.connectors.some(function (connector) {
        return connector.headId === nodeId1 && connector.tailId === nodeId2 || connector.headId === nodeId2 && connector.tailId === nodeId1;
      });
    };

    _this.panTo = function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          id = _ref2[1];

      if (type === 'node') {
        var node = _this.props.tree.nodes.find(function (node) {
          return node.name === id;
        });

        if (node) {
          _this.canvasRef.current.focusPoint({
            x: node.position.x + constants.NODE_CENTER_X,
            y: node.position.y + constants.NODE_CENTER_Y
          }, _this.sidebarRef.current);
        }
      } else {
        var connector = _this.props.tree.connectors.find(function (connector) {
          return connector.id === id;
        });

        var headPosition = _this.props.tree.nodes.get(connector.headId).position;

        var tailPosition = _this.props.tree.nodes.get(connector.tailId).position;

        _this.canvasRef.current.focusPoint({
          x: (headPosition.x + tailPosition.x + constants.NODE_WIDTH) / 2,
          y: (headPosition.y + tailPosition.y + constants.NODE_HEIGHT) / 2
        }, _this.sidebarRef.current);
      }
    };

    _this.getConnectorsByHead = function (nodeId) {
      return Object.values(_this.connectorMap.byHead[nodeId] || {});
    };

    _this.getConnectorsByTail = function (nodeId) {
      return Object.values(_this.connectorMap.byTail[nodeId] || {});
    };

    _this.getChildNodes = function (nodeId) {
      return Object.keys(_this.connectorMap.byTail[nodeId] || {}).map(function (connectorId) {
        return _this.props.tree.connectors.get(parseInt(connectorId));
      }).map(function (connector) {
        return _this.props.tree.nodes.get(connector.headId);
      });
    };

    _this.dragNewConnector = function (node) {
      return function (position) {
        if (!_this.state.newConnector) {
          _this.setState(function (state) {
            return {
              newConnector: state.newConnector || ConnectorModel({
                tailId: node.id
              })
            };
          });
        }

        if (_this.newConnector.current) {
          _this.newConnector.current.setTreeBuilder(_assertThisInitialized(_this));

          _this.newConnector.current.setHead(position, true);
        }
      };
    };

    _this.dropNewConnector = function () {
      if (_this.newConnector.current) {
        _this.newConnector.current.dropHead();
      }

      _this.setState({
        newConnector: null
      });
    };

    _this.registerConnector = function (connector) {
      return function (connectorInstance) {
        var headId = connector.headId,
            id = connector.id,
            tailId = connector.tailId;
        _this.connectorMap.byHead[headId] = _this.connectorMap.byHead[headId] || {};
        _this.connectorMap.byTail[tailId] = _this.connectorMap.byTail[tailId] || {};

        if (connectorInstance) {
          connectorInstance.setTreeBuilder(_assertThisInitialized(_this));
          _this.connectorMap.byHead[headId][id] = connectorInstance;
          _this.connectorMap.byTail[tailId][id] = connectorInstance;
        } else {
          delete _this.connectorMap.byHead[headId][id];
          delete _this.connectorMap.byTail[tailId][id];
        }
      };
    };

    _this.registerNode = function (node) {
      return function (nodeInstance) {
        var id = node.id;

        if (nodeInstance) {
          nodeInstance.setTreeBuilder(_assertThisInitialized(_this));
          _this.nodeMap[id] = nodeInstance;
        } else {
          delete _this.nodeMap[id];
        }
      };
    };

    _this.watchDrag = function () {
      var _this$canvasRef$curre;

      return (_this$canvasRef$curre = _this.canvasRef.current).watchDrag.apply(_this$canvasRef$curre, arguments);
    };

    _this.isDirty = function (treeBuilderState) {
      return treeBuilderState && !is(treeBuilderState.lastSave, treeBuilderState.tree);
    };

    _this.state = {
      newConnector: null
    };
    _this.newConnector = createRef();
    _this.canvasRef = createRef();
    _this.connectorMap = {
      byHead: {},
      byTail: {}
    };
    _this.nodeMap = {};
    _this.sidebarRef = createRef();
    return _this;
  }

  _createClass(TreeBuilderComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkConfig();
      this.checkHighlight();
      window.addEventListener('beforeunload', this.beforeunload.bind(this));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this.checkConfig();
      this.checkHighlight(prevProps);
      window.removeEventListener('beforeunload', this.beforeunload.bind(this));
    }
  }, {
    key: "beforeunload",
    value: function beforeunload(e) {
      if (this.isDirty(this.props.treeBuilderState)) {
        e.preventDefault();
        e.returnValue = true;
      }
    }
  }, {
    key: "checkConfig",
    value: function checkConfig() {
      // until this instance of the tree builder is mounted the builder state will
      // be undefined (not in redux at all), once mounted it will be set to a null
      // placeholder then we will call configureTreeBuilder with the component's
      // props at that time
      if (this.props.treeBuilderState === null) {
        configureTreeBuilder(pick(this.props, ['treeKey', 'sourceName', 'sourceGroup', 'name']));
      }
    }
  }, {
    key: "checkHighlight",
    value: function checkHighlight() {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.props.treeBuilderState && !this.props.treeBuilderState.loading) {
        // one the first "real" render of the tree builder check for the highlight
        // node and focus if one is specified
        if ((!prevProps.treeBuilderState || prevProps.treeBuilderState.loading) && this.props.highlight) {
          this.panTo(this.props.highlight);
        } // otherwise check for changes to the highlight prop and focus if it changes
        // and its a truthy value
        else if (this.props.highlight && !this.props.highlight.equals(prevProps.highlight)) {
            this.panTo(this.props.highlight);
          }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          highlight = _this$props.highlight,
          selected = _this$props.selected,
          treeBuilderState = _this$props.treeBuilderState,
          treeKey = _this$props.treeKey;

      var _ref3 = highlight || [],
          _ref4 = _slicedToArray(_ref3, 2),
          highlightType = _ref4[0],
          highlightId = _ref4[1];

      if (treeBuilderState) {
        var redoStack = treeBuilderState.redoStack,
            saving = treeBuilderState.saving,
            tasks = treeBuilderState.tasks,
            tree = treeBuilderState.tree,
            undoStack = treeBuilderState.undoStack;
        return this.props.children({
          actions: {
            deleteConnector: function deleteConnector(id) {
              return dispatch('TREE_REMOVE_CONNECTOR', {
                treeKey: treeKey,
                id: id
              });
            },
            deleteNode: function deleteNode(id) {
              return dispatch('TREE_REMOVE_NODE', {
                treeKey: treeKey,
                id: id
              });
            },
            updateConnector: function updateConnector(values) {
              return dispatch('TREE_UPDATE_CONNECTOR', _objectSpread({
                treeKey: treeKey
              }, values));
            },
            updateNode: function updateNode(values, dependencies) {
              return dispatch('TREE_UPDATE_NODE', _objectSpread(_objectSpread({
                treeKey: treeKey
              }, values), {}, {
                dependencies: dependencies
              }));
            },
            save: function save(_ref5) {
              var _ref5$overwrite = _ref5.overwrite,
                  overwrite = _ref5$overwrite === void 0 ? false : _ref5$overwrite,
                  _ref5$newName = _ref5.newName,
                  newName = _ref5$newName === void 0 ? '' : _ref5$newName,
                  _ref5$onError = _ref5.onError,
                  onError = _ref5$onError === void 0 ? _this2.props.onError : _ref5$onError,
                  _ref5$onSave = _ref5.onSave,
                  onSave = _ref5$onSave === void 0 ? _this2.props.onSave : _ref5$onSave;
              dispatch('TREE_SAVE', {
                newName: newName,
                overwrite: overwrite,
                onError: onError,
                onSave: onSave,
                treeKey: treeKey
              });
            },
            undo: !undoStack.isEmpty() ? function () {
              return dispatch('TREE_UNDO', {
                treeKey: treeKey
              });
            } : null,
            redo: !redoStack.isEmpty() ? function () {
              return dispatch('TREE_REDO', {
                treeKey: treeKey
              });
            } : null,
            zoomIn: function zoomIn() {
              return _this2.canvasRef.current.zoomIn();
            },
            zoomOut: function zoomOut() {
              return _this2.canvasRef.current.zoomOut();
            }
          },
          dirty: this.isDirty(treeBuilderState),
          name: tree.name,
          saving: saving,
          sidebarRef: this.sidebarRef,
          tasks: tasks,
          tree: tree,
          treeBuilder: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(SvgCanvas, {
            ref: this.canvasRef
          }, tree.connectors.map(function (connector) {
            return /*#__PURE__*/React.createElement(Connector, {
              key: connector.id,
              ref: _this2.registerConnector(connector),
              treeKey: treeKey,
              connector: connector,
              headNode: tree.nodes.get(connector.headId),
              tailNode: tree.nodes.get(connector.tailId),
              highlighted: highlightType === 'connector' && highlightId === connector.id,
              primary: selected.getIn([0, 'connectorId']) === connector.id,
              selected: selected.some(function (_ref6) {
                var connectorId = _ref6.connectorId;
                return connectorId === connector.id;
              }),
              onSelect: _this2.props.onSelectConnector
            });
          }).toList(), this.state.newConnector && /*#__PURE__*/React.createElement(Connector, {
            ref: this.newConnector,
            treeKey: treeKey,
            connector: this.state.newConnector,
            tailNode: tree.nodes.get(this.state.newConnector.tailId)
          }), tree.nodes.map(function (node) {
            return /*#__PURE__*/React.createElement(Node, {
              key: node.id,
              ref: _this2.registerNode(node),
              treeKey: treeKey,
              node: node,
              highlighted: highlightType === 'node' && highlightId === node.name,
              primary: selected.getIn([0, 'nodeId']) === node.id,
              selected: selected.some(function (_ref7) {
                var nodeId = _ref7.nodeId;
                return nodeId === node.id;
              }),
              onNew: _this2.props.onNew,
              onSelect: _this2.props.onSelectNode,
              tasks: tasks,
              tree: tree
            });
          }).toList()))
        });
      }

      return null;
    }
  }]);

  return TreeBuilderComponent;
}(Component);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    treeBuilderState: state.getIn(['trees', props.treeKey]),
    tree: state.getIn(['trees', props.treeKey, 'tree'])
  };
};

export var TreeBuilder = connect(mapStateToProps)(TreeBuilderComponent);